import type { ComputedRef, InjectionKey } from 'vue';

/**
 * The name of the record a related link sits inside, provided by RecordBody.
 * A link that opens a peek passes it on, so the peek's trail starts with the
 * record the person was looking at: "Angelica Waelchi III › Main St Café".
 *
 * A link in a table cell is not inside a record, so it finds nothing here, and
 * its peek's trail starts with the peeked record.
 */
export const PEEK_ORIGIN_TITLE: InjectionKey<ComputedRef<string>> = Symbol('peek-origin-title');
